import {
  OfflineConfigManager,
  ClientStage,
  OfflineClientSettings,
} from '@amzn/amazon-config-store-type-script-offline-adapter';
import { MarketplaceConfigClientProvider } from '@amzn/marketplace-config-type-script-client/dist/marketplaceConfig';
import MarketplaceConfigDoc from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/documents.json';
import MarketplaceConfigQueries from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/queries.json';
import MarketplaceConfigHQ from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/hierarchical_queries.json';
import MarketplaceConfigContext from '@amzn/marketplace-config-type-script-client/dist/marketplaceConfig/MarketplaceConfigContext';
import MarketplaceConfigDocDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/documents.json';
import MarketplaceConfigQueriesDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/queries.json';
import MarketPlaceConfigHQDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/hierarchical_queries.json';
import { NodeEnv } from 'src/constants';

const stage = process.env.NODE_ENV || NodeEnv.development;

function computeClientStage(stage: string): ClientStage {
  return stage === NodeEnv.production ? ClientStage.PROD : ClientStage.DEVO;
}

export const RETAIL_FAMILY = 'retail';
const configManager = new OfflineConfigManager();
const marketplaceConfigClient = configManager.createClient(
  new MarketplaceConfigClientProvider(),
  {
    load: () => ({
      documents:
        NodeEnv.production === ClientStage.PROD
          ? MarketplaceConfigDoc.documents
          : MarketplaceConfigDocDevo.documents,
      exactQueries:
        NodeEnv.production === ClientStage.PROD
          ? MarketplaceConfigQueries.queries
          : MarketplaceConfigQueriesDevo.queries,
      hierarchicalFallbackQueries:
        NodeEnv.production === ClientStage.PROD
          ? MarketplaceConfigHQ.queries
          : MarketPlaceConfigHQDevo.queries,
    }),
  },
  new OfflineClientSettings({ stage: computeClientStage(stage) }),
);

export const getCountyCodeByMarketplace = (marketplaceId: string): string => {
  return (
    marketplaceConfigClient.getMarketplace(
      new MarketplaceConfigContext(marketplaceId),
    )?.defaultCountryCode || ''
  );
};
